import { render, staticRenderFns } from "./NomeGrupoForm.vue?vue&type=template&id=95961e54&"
import script from "./NomeGrupoForm.vue?vue&type=script&lang=js&"
export * from "./NomeGrupoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports